(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ssq-soft-club-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-ssq-soft-club]');
    const teaser = document.querySelector('[data-ssq-soft-club-teaser]');

    if (!dialog || !teaser || dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';

    const dismissalKey = 'ssqSoftClubDismissedUntil';
    const pageViewKey = 'ssqSoftClubPageViews';
    const sessionShownKey = 'ssqSoftClubShown';
    const fourteenDays = 14 * 24 * 60 * 60 * 1000;
    const oneHundredEightyDays = 180 * 24 * 60 * 60 * 1000;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const isFinePointer = window.matchMedia('(pointer: fine)').matches;
    const success = dialog.querySelector('[data-ssq-soft-club-success]');
    const error = dialog.querySelector('[data-ssq-soft-club-error]');
    const email = dialog.querySelector('input[type="email"]');
    const closeButtons = dialog.querySelectorAll('[data-ssq-soft-club-close]');
    let previousFocus = null;
    let openTimer = null;

    const readStorage = (storage, key) => {
      try {
        return storage.getItem(key);
      } catch (_error) {
        return null;
      }
    };

    const writeStorage = (storage, key, value) => {
      try {
        storage.setItem(key, value);
      } catch (_error) {
        return;
      }
    };

    const showTeaser = () => {
      teaser.hidden = false;
    };

    const openDialog = (focusSuccess = false) => {
      if (dialog.open) return;
      previousFocus = document.activeElement;
      teaser.hidden = true;
      document.documentElement.classList.add('ssq-soft-club-open');

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      window.requestAnimationFrame(() => {
        if (focusSuccess && success) {
          success.focus({ preventScroll: true });
        } else if (!isMobile) {
          email?.focus({ preventScroll: true });
        } else {
          dialog.querySelector('[data-ssq-soft-club-close]')?.focus({ preventScroll: true });
        }
      });
    };

    const closeDialog = ({ remember = true, keepHidden = false } = {}) => {
      if (openTimer) window.clearTimeout(openTimer);
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('ssq-soft-club-open');

      if (remember) {
        writeStorage(window.localStorage, dismissalKey, String(Date.now() + fourteenDays));
      }

      if (!keepHidden) showTeaser();
      previousFocus?.focus?.({ preventScroll: true });
    };

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closeDialog());
    });

    teaser.addEventListener('click', (event) => {
      event.preventDefault();
      window.requestAnimationFrame(() => openDialog(false));
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });

    dialog.addEventListener('click', (event) => {
      const bounds = dialog.getBoundingClientRect();
      const outside =
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom;

      if (outside) closeDialog();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(
        dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
      );
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (success) {
      writeStorage(window.localStorage, dismissalKey, String(Date.now() + oneHundredEightyDays));
      writeStorage(window.sessionStorage, sessionShownKey, 'true');
      openDialog(true);
      return;
    }

    if (error) {
      openDialog(false);
      return;
    }

    const dismissedUntil = Number(readStorage(window.localStorage, dismissalKey) || 0);
    if (dismissedUntil > Date.now()) {
      showTeaser();
      return;
    }

    const previousViews = Number(readStorage(window.sessionStorage, pageViewKey) || 0);
    const pageViews = previousViews + 1;
    writeStorage(window.sessionStorage, pageViewKey, String(pageViews));

    if (readStorage(window.sessionStorage, sessionShownKey) === 'true' || pageViews < 2) return;

    const showOnce = () => {
      if (readStorage(window.sessionStorage, sessionShownKey) === 'true') return;
      if (document.visibilityState !== 'visible') return;
      writeStorage(window.sessionStorage, sessionShownKey, 'true');
      openDialog(false);
    };

    openTimer = window.setTimeout(showOnce, isMobile ? 20000 : 12000);

    if (isFinePointer && !isMobile) {
      document.addEventListener(
        'mouseout',
        (event) => {
          if (!event.relatedTarget && event.clientY <= 6) showOnce();
        },
        { once: true }
      );
    }

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && !dialog.open && pageViews >= 2) {
        if (readStorage(window.sessionStorage, sessionShownKey) !== 'true') {
          openTimer = window.setTimeout(showOnce, isMobile ? 20000 : 12000);
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
